/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css, jsx } from '@compiled/react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Anchor, Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const thumbnailContainerStyles = xcss({
	gridArea: 'body',
});

const thumbnailImageStyles = css({
	objectFit: 'cover',
	borderRadius: token('radius.medium'),
	height: '108px',
	width: '224px',
	borderWidth: token('border.width.selected'),
	borderStyle: 'solid',
	borderColor: token('color.text.disabled', '#091E4224'),
});

const descriptionLinkStyles = xcss({
	display: 'inline-block',
});

interface SearchResultThumbnailProps {
	resultUrl: string;
	thumbnailUrl?: string;
}

export const SearchResultThumbnail = ({ resultUrl, thumbnailUrl }: SearchResultThumbnailProps) =>
	thumbnailUrl ? (
		<Anchor xcss={[descriptionLinkStyles]} rel={'noreferrer'} target={'_blank'} href={resultUrl}>
			<Box testId="thumbnail-container" xcss={thumbnailContainerStyles}>
				{/* eslint-disable-next-line @atlassian/a11y/alt-text */}
				<img css={thumbnailImageStyles} src={thumbnailUrl} />
			</Box>
		</Anchor>
	) : null;
